import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/joy";
import { Clear as ClearIcon } from "@mui/icons-material";
import { OrgThemeBackgrounds } from "../../../common/types";
import ColorInput from "./ColorInput";

interface BackgroundEditorProps {
  value: OrgThemeBackgrounds;
  onChange: (v: OrgThemeBackgrounds) => void;
  disabled?: boolean;
  mode?: "light" | "dark";
}

const ROWS = [
  { field: "body" as keyof OrgThemeBackgrounds,    label: "Page background" },
  { field: "surface" as keyof OrgThemeBackgrounds, label: "Card / surface"  },
];

const PLACEHOLDERS = {
  light: { body: "#f5f5f5", surface: "#f8fafc" },
  dark:  { body: "#000000", surface: "#181820" },
};

const BackgroundEditor: React.FC<BackgroundEditorProps> = ({
  value,
  onChange,
  disabled,
  mode = "light",
}) => {
  const placeholders = PLACEHOLDERS[mode];
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {ROWS.map(({ field, label }) => (
        <Box key={field} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            level="body-xs"
            sx={{ minWidth: 120, flexShrink: 0, color: "text.secondary" }}
          >
            {label}
          </Typography>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <ColorInput
              value={value[field] ?? ""}
              onChange={(hex) => onChange({ ...value, [field]: hex || undefined })}
              disabled={disabled}
              placeholder={placeholders[field] ?? "#000000"}
            />
          </Box>
          <Tooltip title="Clear (inherit theme default)" placement="top">
            <span>
              <IconButton
                size="sm"
                variant="plain"
                color="neutral"
                disabled={disabled || !value[field]}
                onClick={() => onChange({ ...value, [field]: undefined })}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      ))}
    </Box>
  );
};

export default BackgroundEditor;
